import React from 'react';

import { ExperienceLevel } from '@commonTuna/react/objects/ExperienceLevel';

interface Props {
	experience?: ExperienceLevel;
}

export const ExperienceLevelNames = {
	[ExperienceLevel.ZeroToTwoYears]: '0-2',
	[ExperienceLevel.ThreeToFiveYears]: '3-5',
	[ExperienceLevel.SixToTenYears]: '6-10',
	[ExperienceLevel.ElevenToTwentyYears]: '11-20',
	[ExperienceLevel.TwentyPlusYears]: '20+',
};

const Experience: React.FC<Props> = ({ experience }) => {
	return experience !== undefined && ExperienceLevelNames[experience]
		? <div className="experience">
			<i className="fa fa-bookmark" style={{ color: '#f60' }} />
			{' '}
			{ExperienceLevelNames[experience]}
			{' Years '}
			<span className="mobile-hide">
				of Experience
			</span>
		</div> : null;
};

export default Experience;
